import React, { useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  TextField,
  MenuItem,
  Button
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { vendorApi } from '../../api/api';

const EditApartmentPlotsDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { PropertyData } = location.state || {};
  const property = PropertyData?.[0] || {};
  const parkingTypes = ['car', 'bike', 'both'];
  const parseDescription = (desc) => {
    try {
      if (!desc) return "";
      const arr = JSON.parse(desc);
      return Array.isArray(arr) ? arr.join("\n") : "";
    } catch {
      return "";
    }
  };

  // helper → normalize boolean values ("yes"/"Yes"/"no" → true/false)
  const normalizeBool = (val) =>
    String(val).toLowerCase() === 'yes' || String(val).toLowerCase() === 'true';

  const [formData, setFormData] = useState({
    ApartmentName: property.ApartmentName || '',
    PlotName: property.PlotName || '',
    Address: property.Address || '',
    City: property.City || '',
    Description: parseDescription(property.Description),
    Bedrooms: Number(property.Amenities?.Bedrooms) || 0,
    Bathrooms: Number(property.Amenities?.Bathrooms) || 0,
    Balcony: Number(property.Amenities?.Balcony) || 0,
    TotalFloors: Number(property.TotalFloors) || 0,
    percentagevalue: Number(property.percentagevalue) || null,
    sqftamount: Number(property.sqftamount) || null,
    ParkingType: property.Amenities?.ParkingType || '',
    PowerBackUp: property.Amenities?.PowerBackUp || '',
    WaterSupply: property.Amenities?.WaterSupply || '',
    MaintenanceCharges: Number(property.Amenities?.MaintenanceCharges) || 0,
    Facing: property.Facing || '',
    AgeOfBuilding: Number(property.Amenities?.AgeOfBuilding) || 0,
    SizeInSqFt: Number(property.SizeInSqFt) || 0,
    LandArea: property.LandArea || '',
    MarketPrice: Number(property.MarketPrice) || 0,
    CCTVAvailable: normalizeBool(property.Amenities?.CCTVAvailable),
    GatedSecurity: normalizeBool(property.Amenities?.GatedSecurity),
    LiftAvailable: normalizeBool(property.Amenities?.LiftAvailable),
    ParkingAvailable: normalizeBool(property.Amenities?.ParkingAvailable),
    AddedOn: property.AddedOn || '',
  });
  const [priceMode, setPriceMode] = useState(
    formData.percentagevalue != null ? "percentage"
      : formData.sqftamount != null ? "sqft"
        : ""
  );

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    setFormData((prev) => {
      if (name === "percentagevalue") {
        return {
          ...prev,
          percentagevalue: value === "" ? null : Number(value),
          sqftamount: null,
        };
      }

      if (name === "sqftamount") {
        return {
          ...prev,
          sqftamount: value === "" ? null : Number(value),
          percentagevalue: null,
        };
      }

      return {
        ...prev,
        [name]: type === "number" ? Number(value) : value,
      };
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      Id: property.Id,
      ApartmentName: formData.ApartmentName,
      PlotName: formData.PlotName,
      Address: formData.Address,
      City: formData.City,
      Facing: formData.Facing,
      LandArea: formData.LandArea,
      SizeInSqFt: formData.SizeInSqFt,
      TotalFloors: formData.TotalFloors,
      // ✅ SEND PRICE VALUES
      percentagevalue: formData.percentagevalue,
      sqftamount: formData.sqftamount,
  // ✅ FIX DESCRIPTION
  Description: JSON.stringify(
    formData.Description
      .split("\n")
      .map(line => line.trim())
      .filter(line => line.length > 0)
  ),
      GeoLocation: property.GeoLocation || null,
      Amenities: {
        Bedrooms: formData.Bedrooms,
        Bathrooms: formData.Bathrooms,
        Balcony: formData.Balcony,
        PowerBackUp: formData.PowerBackUp,
        WaterSupply: formData.WaterSupply,
        MaintenanceCharges: formData.MaintenanceCharges,
        AgeOfBuilding: formData.AgeOfBuilding,
        CCTVAvailable: formData.CCTVAvailable ? "Yes" : "No",
        GatedSecurity: formData.GatedSecurity ? "Yes" : "No",
        LiftAvailable: formData.LiftAvailable ? "Yes" : "No",
        ParkingAvailable: formData.ParkingAvailable ? "Yes" : "No",
        ...(formData.ParkingAvailable ? { ParkingType: formData.ParkingType } : {}),
      },
    };


    try {
      const res = await vendorApi.editApartmentDetails(payload);
      alert('Edit Apartment Details Successfully');
      setTimeout(() => {
        navigate("/apartment");
      }, 2000);
    } catch (err) {
      console.error('Failed to update:', err);
      alert('Failed to update apartment details.');
    }
  };

  return (
    <Box sx={{ maxWidth: '95%', mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3, backgroundColor: '#f9f9f9' }}>
        <Typography variant="h5" gutterBottom>
          Edit Apartment Plot Details
        </Typography>

        {/* Show AddedOn */}
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Added On: {new Date(formData.AddedOn).toLocaleString()}
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ paddingTop: '20px' }}>
          <Grid container spacing={2}>
            {[
              { label: 'Apartment Name', name: 'ApartmentName' },
              { label: 'Plot Name', name: 'PlotName' },
              { label: 'Address', name: 'Address' },
              { label: 'City', name: 'City' },
              { label: 'Bedrooms', name: 'Bedrooms', type: 'number' },
              { label: 'Bathrooms', name: 'Bathrooms', type: 'number' },
              { label: 'Balcony', name: 'Balcony', type: 'number' },
              { label: 'Total Floors', name: 'TotalFloors', type: 'number' },
              { label: 'Maintenance Charges', name: 'MaintenanceCharges', type: 'number' },
              { label: 'Facing', name: 'Facing' },
              { label: 'Age Of Building', name: 'AgeOfBuilding', type: 'number' },
              { label: 'Size (Sq. Ft.)', name: 'SizeInSqFt', type: 'number' },
              { label: 'Land Area', name: 'LandArea' },
              { label: 'Market Price', name: 'MarketPrice', type: 'number', disabled: true },
              { label: 'Power Backup', name: 'PowerBackUp' },
              { label: 'Water Supply', name: 'WaterSupply' },
            ].map((field) => (
              <Grid item xs={12} sm={6} md={4} key={field.name}>
                <TextField
                  fullWidth
                  label={field.label}
                  name={field.name}
                  type={field.type || 'text'}
                  value={formData[field.name]}
                  onChange={handleChange}
                  disabled={field.disabled}
                />
              </Grid>
            ))}
            {/* Conditionally Show Parking Type */}
            {formData.ParkingAvailable && (
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  fullWidth
                  select
                  label="Parking Type"
                  name="ParkingType"
                  value={formData.ParkingType}
                  onChange={handleChange}
                >
                  {parkingTypes.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            )}
            {/* Price Section */}
            <Grid container spacing={2} alignItems="center" sx={{ marginLeft: 1, marginTop: 1 }}>

              {/* Price Type Select */}
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  select
                  fullWidth
                  label="Price Calculation Type"
                  value={priceMode}
                  onChange={(e) => {
                    const mode = e.target.value;
                    setPriceMode(mode);
                    setFormData((prev) => ({
                      ...prev,
                      percentagevalue: mode === "percentage" ? prev.percentagevalue : null,
                      sqftamount: mode === "sqft" ? prev.sqftamount : null,
                    }));
                  }}
                >
                  <MenuItem value="percentage">Percentage (%)</MenuItem>
                  <MenuItem value="sqft">Amount per Sqft</MenuItem>
                </TextField>
              </Grid>

              {/* Percentage Input */}
              {priceMode === "percentage" && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Percentage (%)"
                    name="percentagevalue"
                    value={formData.percentagevalue ?? ""}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
              )}

              {/* Sqft Input */}
              {priceMode === "sqft" && (
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Amount per Sqft"
                    name="sqftamount"
                    value={formData.sqftamount ?? ""}
                    onChange={handleChange}
                    inputProps={{ min: 0 }}
                  />
                </Grid>
              )}

            </Grid>



          </Grid>

          {/* Boolean Fields */}
          <Grid container spacing={2} mt={2} >
            {[
              { label: 'CCTV Available', name: 'CCTVAvailable' },
              { label: 'Gated Security', name: 'GatedSecurity' },
              { label: 'Lift Available', name: 'LiftAvailable' },
              { label: 'Parking Available', name: 'ParkingAvailable' },
            ].map((field) => (
              <Grid item xs={12} sm={6} md={3} key={field.name}>
                <TextField
                  select
                  fullWidth
                  label={field.label}
                  name={field.name}
                  value={formData[field.name] ? 'Yes' : 'No'}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      [field.name]: e.target.value === 'Yes',
                    }))
                  }
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={12} mt={2}>
            <TextField
              fullWidth
              multiline
              rows={5}
              label="Description (one point per line)"
              name="Description"
              value={formData.Description}
              onChange={handleChange}
              placeholder={`Point 1\nPoint 2\nPoint 3`}
            />
          </Grid>

          {/* Buttons */}
          <Box mt={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
              sx={{ width: '15%', marginRight: 5 }}
            >
              Cancel
            </Button>
            <Button variant="contained" type="submit" sx={{ width: '20%' }}>
              Save Changes
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default EditApartmentPlotsDetails;